module.exports = __webpack_public_path__ + "static/2-invert-c03c94498939ffc8a5fd1a60f197da49.jpg";